var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.canPrint
    ? _c(
        "button",
        {
          staticClass: "btn btn-sm btn-info",
          attrs: {
            disabled: _vm.printingBadge,
            title: _vm.$t("visitorManagement.badge.tooltip.print")
          },
          on: { click: _vm.printBadge }
        },
        [
          _vm.printingBadge
            ? _c("Spinner", { attrs: { small: true } })
            : _c("i", { staticClass: "fa fa-id-badge" })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }